import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.restaurant-le-mas.fr';
const SITE_NAME = 'Le Mas — Restaurant & Traiteur';
const DEFAULT_IMAGE = '/images/restaurant/hero.jpg';
const PHONE = '04 68 38 06 98';
const ADDRESS = {
  street: '6 Avenue Marechal Joffre',
  city: 'Saint-Laurent-de-la-Salanque',
  zip: '66250',
  region: 'Occitanie',
  country: 'FR',
};

export function SEO({ title, description, path = '/', image, type = 'website', noindex = false, schema }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const fullUrl = `${SITE_URL}${path}`;
  const fullImage = image ? (image.startsWith('http') ? image : `${SITE_URL}${image}`) : `${SITE_URL}${DEFAULT_IMAGE}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Geo */}
      <meta name="geo.region" content="FR-66" />
      <meta name="geo.placename" content="Saint-Laurent-de-la-Salanque" />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}

export const SCHEMA_RESTAURANT = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "name": "Le Mas",
  "alternateName": "Le Mas Restaurant & Traiteur",
  "url": SITE_URL,
  "telephone": "+33468380698",
  "email": "contact@restaurant-le-mas.fr",
  "image": `${SITE_URL}/images/restaurant/hero.jpg`,
  "logo": `${SITE_URL}/images/logo-restaurant.jpg`,
  "description": "Restaurant et traiteur a Saint-Laurent-de-la-Salanque. Cuisine mediterraneenne, catalane et francaise. Terrasse, salle privee, menus du jour, traiteur evenements.",
  "servesCuisine": ["Francaise", "Mediterraneenne", "Catalane"],
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": ADDRESS.street,
    "addressLocality": ADDRESS.city,
    "postalCode": ADDRESS.zip,
    "addressRegion": ADDRESS.region,
    "addressCountry": ADDRESS.country
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 42.7725,
    "longitude": 2.9914
  },
  "openingHoursSpecification": [
    { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Tuesday", "Wednesday", "Thursday", "Friday"], "opens": "12:00", "closes": "14:00" },
    { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], "opens": "19:30", "closes": "22:00" },
    { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Saturday", "Sunday"], "opens": "12:00", "closes": "14:00" }
  ],
  "hasMenu": {
    "@type": "Menu",
    "url": `${SITE_URL}/site/restaurant/menu`,
    "name": "La Carte du Mas"
  },
  "acceptsReservations": "True",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.5",
    "reviewCount": "320",
    "bestRating": "5"
  }
};

export const SCHEMA_TRAITEUR = {
  "@context": "https://schema.org",
  "@type": "FoodService",
  "name": "Le Mas Traiteur",
  "url": `${SITE_URL}/site/traiteur`,
  "telephone": "+33468380698",
  "image": `${SITE_URL}/images/traiteur/hero.jpg`,
  "description": "Traiteur evenementiel a Saint-Laurent-de-la-Salanque. Mariages, anniversaires, repas d'entreprise, plateaux repas. Cuisine catalane et mediterraneenne.",
  "areaServed": {
    "@type": "GeoCircle",
    "geoMidpoint": { "@type": "GeoCoordinates", "latitude": 42.7725, "longitude": 2.9914 },
    "geoRadius": "50000"
  },
  "address": {
    "@type": "PostalAddress",
    "streetAddress": ADDRESS.street,
    "addressLocality": ADDRESS.city,
    "postalCode": ADDRESS.zip,
    "addressRegion": ADDRESS.region,
    "addressCountry": ADDRESS.country
  }
};
